import React from 'react';
import { Box, Typography, Stack } from '@mui/material';

/**
 * Top-of-page title block. Replaces the bespoke title rows on every page.
 *
 *   <PageHeader
 *     title="Dashboard"
 *     subtitle="Welcome back, Harley"
 *     actions={<><Button>...</Button></>}
 *   />
 */
const PageHeader = ({ title, subtitle, actions, children }) => (
  <Box sx={{ mb: 3 }}>
    <Stack
      direction={{ xs: 'column', md: 'row' }}
      alignItems={{ md: 'flex-start' }}
      justifyContent="space-between"
      spacing={2}
    >
      <Box>
        <Typography
          component="h1"
          sx={{
            fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif',
            fontSize: { xs: '1.375rem', md: '1.5rem' },
            fontWeight: 600,
            color: 'text.primary',
            lineHeight: 1.25,
            letterSpacing: '-0.01em',
          }}
        >
          {title}
        </Typography>
        {subtitle && (
          <Typography
            sx={{
              fontFamily: '"Inter", sans-serif',
              fontSize: '0.875rem',
              color: 'text.secondary',
              mt: 0.5,
            }}
          >
            {subtitle}
          </Typography>
        )}
      </Box>
      {actions && <Box>{actions}</Box>}
    </Stack>
    {children && <Box sx={{ mt: 2 }}>{children}</Box>}
  </Box>
);

export default PageHeader;
